// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import TrioColorGradientTemplate from '@front/templates/TrioColorGradientTemplate.html';
import { ContainerControl } from './ContainerControl';
export class TrioColorGradient extends ContainerControl {
    constructor() {
        super();
    }
}
ContainerControl.extendWith(TrioColorGradient, {
    data: function () {
        return {
            value: null
        };
    },
    template: TrioColorGradientTemplate
});
